/* eslint no-param-reassign: 0 */
import axios from 'axios';
import {
  FETCH_APPOINTMENT_SUCCESS,
  FETCH_VIDEO_TOKEN_REQUEST,
  FETCH_VIDEO_TOKEN_SUCCESS,
  FETCH_VIDEO_TOKEN_FAILURE,
  UPDATE_APPOINTMENT,
  UPDATE_APPOINTMENT_SESSIONS,
  FETCH_APPOINTMENT_NOTE,
  UPDATE_APPOINTMENT_NOTE,
  FETCH_APPOINTMENT_NOTES,
  UPDATE_ASSESSMENT_SCORE,
  UNAUTH_USER,
} from '../types';

import { headers } from '../defaults';
import { API_URL } from '../../environment';

export function fetchAppointment(id, callback = () => {}, onError = () => {}) {
  return dispatch => {
    dispatch({ type: 'FETCH_APPOINTMENT_REQUEST' });
    axios
      .get(`${API_URL}/appointments/${id}`, headers())
      .then(response => {
        dispatch({
          type: FETCH_APPOINTMENT_SUCCESS,
          payload: response,
        });
        callback(response);
      })
      .catch(error => {
        dispatch({ type: 'FETCH_APPOINTMENT_FAILURE' });
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
        onError(error);
      });
  };
}

export function fetchVideoToken(id, callback = () => {}) {
  return dispatch => {
    dispatch({ type: FETCH_VIDEO_TOKEN_REQUEST });
    axios
      .post(`${API_URL}/v1/appointments/${id}/video_token`, null, headers())
      .then(response => {
        dispatch({
          type: FETCH_VIDEO_TOKEN_SUCCESS,
          payload: response,
        });
        callback(response);
      })
      .catch(error => {
        dispatch({ type: FETCH_VIDEO_TOKEN_FAILURE });
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
      });
  };
}

export function updateAssessmentScore(values, callback = () => {}) {
  return dispatch => {
    axios
      .put(`${API_URL}/assessment_scores/updatedScores`, values, headers())
      .then(response => {
        dispatch({
          type: UPDATE_ASSESSMENT_SCORE,
          payload: response,
        });
        callback(response);
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
      });
  };
}

export function updateAppointment(id, values, callback = () => {}) {
  return dispatch => {
    axios
      .put(`${API_URL}/appointments/${id}`, values, headers())
      .then(response => {
        dispatch({
          type: UPDATE_APPOINTMENT,
          payload: response,
        });
        callback(response);
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
      });
  };
}

export function updateAppointmentSession(id, values, callback = () => {}) {
  return dispatch => {
    axios
      .put(`${API_URL}/appointment_sessions/${id}`, values, headers())
      .then(response => {
        dispatch({
          type: UPDATE_APPOINTMENT_SESSIONS,
          payload: response,
        });
        callback(response);
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
      });
  };
}

export function fetchAppointmentNote(id, callback = () => {}) {
  return dispatch => {
    axios
      .get(`${API_URL}/appointment_notes/${id}`, headers())
      .then(response => {
        dispatch({
          type: FETCH_APPOINTMENT_NOTE,
          payload: response,
        });
        callback(response);
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
      });
  };
}

export function updateAppointmentNote(id, values, callback = () => {}) {
  return dispatch => {
    axios
      .put(`${API_URL}/appointment_notes/${id}`, values, headers())
      .then(response => {
        dispatch({
          type: UPDATE_APPOINTMENT_NOTE,
          payload: response,
        });
        callback(response);
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
      });
  };
}

export function fetchAppointmentNotes(clientId, callback = () => {}) {
  return dispatch => {
    axios
      .get(`${API_URL}/appointment_notes?client_id=${clientId}`, headers())
      .then(response => {
        dispatch({
          type: FETCH_APPOINTMENT_NOTES,
          payload: response,
        });
        callback(response);
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
      });
  };
}

export const submitSessionFeedback =
  (values, callback = () => {}) =>
  dispatch => {
    axios
      .put(`${API_URL}/v2/appointments/feedback`, values, headers())
      .then(response => {
        dispatch({
          type: 'SUBMIT_SESSION_FEEDBACK',
          payload: response,
        });
        callback(response);
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
      });
  };

export function fetchAppointmentAssessments(
  appointmentId,
  callback = () => {},
) {
  return dispatch => {
    axios
      .get(
        `${API_URL}/practice/assessment_reports/session_assessment_report?appointment_id=${appointmentId}`,
        headers(),
      )
      .then(response => {
        // dispatch({
        //   type: FETCH_APPOINTMENT_ASSESSMENTS,
        //   payload: response,
        // });
        callback(response);
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
      });
  };
}
